import SoFi from './SoFi.png';
import Experian from './experian.svg';
import IntuitQuickBooksFinancing from './intuit.svg';
import MyBusinessLoanCompanion from './MyBusinessLoanCompanion.png';
import Newity from './newity.svg';
import Nav from './nav.svg';
import SmallBusinessLoans from './smallbusinessloans.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  partner: StrategicPartner
  width?: string;
  alt?: string;
}

export const logos = {
  "SoFi Lending": SoFi,
  "Experian": Experian,
  "Newity": Newity,
  "Nav": Nav,
  "Smallbusinessloans.com": SmallBusinessLoans,
  // current name in production, should be removed in the future
  "Smallbusinesssloans.com": SmallBusinessLoans,
  "Intuit QuickBooks Financing": IntuitQuickBooksFinancing,
  "XLT Media Solutions": MyBusinessLoanCompanion,
};

export type StrategicPartner = keyof typeof logos;
export const StrategicPartners = Object.keys(logos) as StrategicPartner[];

export function isStrategicPartner(value: unknown): value is StrategicPartner {
  return (
    typeof value === 'string' &&
    Object.prototype.hasOwnProperty.call(logos, value)
  );
}

export const PartnerLogo = ({ width = "100px", alt = "OnDeck", partner, ...props }: ImageProps) => {
  const logoSrc = logos[partner] || undefined;
  if (!logoSrc) return null;
  return <div {...props}>
    {logoSrc ? <img src={logoSrc} width={width} alt={partner} /> : <div className="fs-3 lh-1 fw-bold">{partner}</div>}
  </div>
}

export default PartnerLogo;
